import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { usePageMeta } from "@/hooks/usePageMeta";
import { EnsoMark } from "@/components/Logo";

const NotFoundPage = () => {
  usePageMeta("Vagus Digital | Page not found");
  return (
    <section className="flex min-h-screen flex-col items-center justify-center bg-paper px-6 py-24 text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        data-testid="not-found-page"
      >
        <EnsoMark className="mx-auto h-14 w-14 text-jade/40" />
        <h1 className="mt-6 font-display text-3xl font-light tracking-tight text-ink sm:text-4xl">
          This page <em className="italic text-jade">wandered off</em>.
        </h1>
        <p className="mx-auto mt-4 max-w-sm leading-relaxed text-ink2">
          The link is broken or the page has moved. Everything that matters is
          one click away.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="rounded-full bg-jade px-7 py-3 text-sm font-medium text-paper transition-colors duration-300 hover:bg-ink"
          >
            Back home
          </Link>
          <Link
            to="/insights"
            data-testid="notfound-insights-link"
            className="rounded-full border border-jade/30 px-7 py-3 text-sm font-medium text-jade transition-colors duration-300 hover:bg-jade/5"
          >
            Read Insights
          </Link>
        </div>
      </motion.div>
    </section>
  );
};

export default NotFoundPage;